import React from "react";
import { PageLayout } from "../components/PageLayout";
import { Cart } from "../features/products/Cart";

export const CartPage: React.FC = () => {
  return <PageLayout>
    <Cart />
  </PageLayout>;
};